//============================================================================
// Name        : push_to_handhelds.ts
// Purpose     : Implement push inventory to handheld
// Created     : 2020-02-12
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import { InitPage } from "../index";

function ProcessHandheld() {
  $("#select_handheld").select2({ width: "70%" });
  let hasSelectableTags = $("input.handheld").length > 0;

  if (!hasSelectableTags) {
    $(".radio").hide();
  }

  $("input[name=all]").on("click", function () {
    var selectedAll = $(this).val();
    switch (selectedAll) {
      case "selected":
        $("#extra_note").text(
          "Note: This option sends data to the selected handheld, and you should use the “Cloud & Geiger” module on the handheld to load the items."
        );
        break;
      case "all":
        $("#extra_note").text(
          "Note: This action will send all existing assets in the inventory to the handheld. If filtered, it will send all the filtered items, and you should use the “Cloud & Geiger” module on the handheld to load the items."
        );
        break;
      case "file-inv":
      case "file-catalog":
      case "file-epc":
        $("#extra_note").text(
          "Note: This option sends data to the selected handheld, and you should use the “Upload & Geiger” module on the handheld to load the items."
        );
        break;
      default:
        $("#extra_note").text(" ");
    }
  });

  $("#send-handheld-submit").on("click", (e) => {
    var selectedHandheld = $("#select_handheld").find(":selected").val();
    if (selectedHandheld === undefined) {
      e.preventDefault();
      $("#error-message").text("There is not any available handheld");
    } else {
      const form = $(this).parent();
      let selected = false;
      selected = $("input[name=all]:checked").val() == "selected";

      if (selected) {
        const ids = [];
        const selectedItems = $(".handheld:checked");

        if (selectedItems.length > 1) {
          for (const it of Array.from(selectedItems)) {
            ids.push($(it).val());
          }
        } else {
          ids.push($(selectedItems).val() as string);
        }
        $("#epc_tags").val(JSON.stringify(ids));
      }

      hasSelectableTags = $("input.handheld").length > 0;
      const epcIds = $(".epc_tag_id");
      console.log(epcIds);
      if (!hasSelectableTags && epcIds.length > 0) {
        const ids = [];
        for (const tag of Array.from(epcIds)) {
          ids.push($(tag).data("epcid"));
        }
        console.log(ids);
        $("#epc_tags").val(JSON.stringify(ids));
      }
      form.submit();
    }
  });
}

export function LoadPage() {
  if ($("#handheld.modal").length > 0) {
    ProcessHandheld();
  }
  $("#handheld").on("hidden.bs.modal", function () {
    $("#error-message").text("");
    $("#extra_note").text(" ");
    $("#selectedRadio").prop("checked", true);
    $(".cont-uploader").attr("style", "color: black; display: none");
  });
  $("#handheld").on("shown.bs.modal", function () {
    $("#extra_note").text(
      "Note: This option sends data to the selected handheld, and you should use the “Cloud & Geiger” module on the handheld to load the items."
    );
    $("#selectedRadio").prop("checked", true);
    $(".cont-uploader").attr("style", "color: black; display: none");
  });
}
